import { useContext } from "react";
import { AppContext } from "../App";
import AboutUsLanding from "../views/AboutUsLanding";

export default function AboutUs() {
  const appContext = useContext(AppContext);

  if (
    !appContext.navSubItem &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding section="overview" />;
  }

  if (
    appContext.navSubItem === "overview" &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding section="overview" />;
  }

  if (
    appContext.navSubItem === "team" &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding section="team" />;
  }

  if (
    appContext.navSubItem === "policies" &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <AboutUsLanding section="policies" />;
  }

  return null;
}
